import React from 'react';
import { ContactButton } from '../../shared/components/contact-button/contact-button';
import '../styles/go-back-buttons.scss';

interface Props {
    history: any;
    bgColor?: string;
    txtColor?: string;
}

export const GoBackButtons: React.FunctionComponent<Props> = props => {
    const goToBeginning = (): void => {
        props.history.push('/');
    };

    const goToTestPicker = (): void => {
        props.history.push('/test-explanation?test=eye-test&all-tests=true');
    };

    return (
        <div className={'go-back--wrapper'}>
            <button className={'go-back__button'}
                    tabIndex={0}
                    onClick={goToBeginning}
                    style={{
                        color: props.txtColor,
                        backgroundColor: props.bgColor
                    }}>
                Zurück zum Anfang
            </button>
            <button className={'go-back__button'}
                    tabIndex={0}
                    onClick={goToTestPicker}
                    style={{
                        color: props.txtColor,
                        backgroundColor: props.bgColor
                    }}>
                Tests wiederholen
            </button>
            <ContactButton/>
        </div>
    );
};
